















import { Component, Vue } from "vue-property-decorator";
import SetReceivingWalletAction from "./SetReceivingWalletAction.vue";
import { State } from "vuex-class";

@Component({
  components: {
    SetReceivingWalletAction
  }
})
class ReceivingWalletAlert extends Vue {
  @State(state => state.hfox.profile) profile;

  get show() {
    return this.profile && !this.profile.platform;
  }
}
export default ReceivingWalletAlert;
